import { CeruleanButton } from 'components/Button'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import { OverlayLoader } from 'components/Loaders'
import formName from 'constants/formName'
import { ChangeEmailFormType } from 'data/Form/ChangeEmail/types'
import messages from 'lang'
import React from 'react'
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl'
import { InjectedFormProps, reduxForm } from 'redux-form'
import { EMAIL_VERIFICATION_CODE_LENGTH } from 'services/api/user'
import styled from 'styled-components'
import { validator } from 'utils'

import Container from '../../Modal/Container'
import preventUserInputCss from '../../Modal/PreventUserInput'
import { PropsType as _P } from '.'

type NotFormProps = _P & WrappedComponentProps
type PropsType = InjectedFormProps<ChangeEmailFormType, NotFormProps> & NotFormProps

const Form = styled.form<{ isLoading: boolean }>`
  ${preventUserInputCss};
`

const ChangeEmail = ({ handleSubmit, intl, isLoading, newEmail, oldEmail, valid }: PropsType) => (
  <Form isLoading={isLoading} onSubmit={handleSubmit}>
    <Container
      sub={
        <FormattedMessage
          {...{
            ...messages.sub_title_change_email,
            values: {
              newEmail: <b>{newEmail}</b>,
              oldEmail: <b>{oldEmail}</b>
            }
          }}
        />
      }
      title={intl.formatMessage(messages.title_change_email)}
    >
      <InputContainer>
        <Field
          component={Input}
          e2e='oldEmailVerificationCode'
          label={intl.formatMessage(messages.label_code_sent_to, {
            email: oldEmail
          })}
          name='oldEmailVerificationCode'
          placeholder={intl.formatMessage(messages.placeholder_code, {
            length: EMAIL_VERIFICATION_CODE_LENGTH
          })}
          validate={[validator.required]}
        />
      </InputContainer>

      <InputContainer>
        <Field
          component={Input}
          e2e='newEmailVerificationCode'
          label={intl.formatMessage(messages.label_code_sent_to, {
            email: newEmail
          })}
          name='newEmailVerificationCode'
          placeholder={intl.formatMessage(messages.placeholder_code, {
            length: EMAIL_VERIFICATION_CODE_LENGTH
          })}
          validate={[validator.required]}
        />
      </InputContainer>

      <CeruleanButton disabled={!valid} e2e='changeEmailButton' type='submit'>
        {intl.formatMessage(messages.button_confirm)}
      </CeruleanButton>
    </Container>

    {isLoading && <OverlayLoader />}
  </Form>
)

export default injectIntl(
  reduxForm<ChangeEmailFormType, NotFormProps>({
    form: formName.CHANGE_EMAIL
  })(ChangeEmail)
)
